export const BOB_OFFSET_Y = 10;
export const BOB_SCALE = 0.75;
